import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-revenue-generation',
  templateUrl: './revenue-generation.component.html',
  styleUrls: ['./revenue-generation.component.css'],
})
export class RevenueGenerationComponent implements OnInit {
  revenues: FormGroup;
  private saveApi = environment.url + 'coe/revenuegeneration/save';
  private getApi = environment.url + 'coe/revenuegeneration/get?id=';
  private deletApi = environment.url + 'coe/revenue/remove?id=';
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    this.revenues = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      revenue: this.fb.array([]),
      totalYear1: [''],
      totalYear2: [''],
      overrallTotal: [''],
    });
  }
  get revenue() {
    return this.revenues.get('revenue') as FormArray;
  }
  ngOnInit(): void {
    this.getDataApi();
  }

  showForm: boolean = false;
  get setting() {
    return this.revenues.controls;
  }
  getValue: any = {};
  disableBtn: boolean;
  show;

  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        if (!data.revenue || data.revenue.length == 0) {
          this.addRevenue();
        }
        if (data.revenue && data.revenue.length > 0) {
          for (let i = 0; i < data.revenue.length; i++) {
            this.addRevenue();
          }
        }
        if (data.responseStatus != 'Failed') {
          this.revenues.patchValue(data);
        }
      });
  }
  // Add Revenue
  addRevenue() {
    let val = this.revenue.length;
    if (val <= 4) {
      const revenuesForm = this.fb.group({
        id: 0,
        description: ['', Validators.required],
        year1: [
          '',
          [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
        ],
        year2: [
          '',
          [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
        ],
        total: [''],
      });

      this.revenue.push(revenuesForm);
    } else {
      this.notify.notifyError('Only 5 Revenue Will be Added');
    }
  }
  // Calculate Total
  calculateTotal1(): void {
    let totalYear1 = 0;
    let totalYear2 = 0;

    this.revenue.controls.forEach((row) => {
      totalYear1 += parseFloat(row.get('year1')?.value || 0);
      totalYear2 += parseFloat(row.get('year2')?.value || 0);

      // Calculate total for this row
      const total = totalYear1 + totalYear2;

      // Format total for display without unnecessary trailing zeros
      const formattedTotal = parseFloat(total.toFixed(2));
      row.get('total')?.setValue(formattedTotal);

      totalYear1 = 0;
      totalYear2 = 0;
    });

    let totalYear11 = 0;
    let totalYear22 = 0;

    this.revenue.controls.forEach((row) => {
      totalYear11 += parseFloat(row.get('year1')?.value || 0);
      totalYear22 += parseFloat(row.get('year2')?.value || 0);
    });

    // Calculate totals for Year1, Year2, and Overall without trailing zeros
    const formattedTotalYear1 = parseFloat(totalYear11.toFixed(2));
    const formattedTotalYear2 = parseFloat(totalYear22.toFixed(2));

    this.revenues.get('totalYear1')?.setValue(formattedTotalYear1);
    this.revenues.get('totalYear2')?.setValue(formattedTotalYear2);

    const overallTotal = totalYear11 + totalYear22;
    const formattedOverallTotal = parseFloat(overallTotal.toFixed(2));
    this.revenues.get('overrallTotal')?.setValue(formattedOverallTotal);
  }
  // Remove
  totalRemove(): void {
    let totalYear1 = 0;
    let totalYear2 = 0;
    this.revenue.controls.forEach((row) => {
      totalYear1 += parseFloat(row.get('year1')?.value || 0);
      totalYear2 += parseFloat(row.get('year2')?.value || 0);
      const total = totalYear1 + totalYear2;
      row.get('total')?.setValue(total);
      totalYear1 = 0;
      totalYear2 = 0;
    });
    let totalYear11 = 0;
    let totalYear22 = 0;
    this.revenue.controls.forEach((row) => {
      totalYear11 += parseFloat(row.get('year1')?.value || 0);
      totalYear22 += parseFloat(row.get('year2')?.value || 0);
    });
    this.revenues.get('totalYear1')?.setValue(totalYear11);
    this.revenues.get('totalYear2')?.setValue(totalYear22);
    const total = totalYear11 + totalYear22;
    this.revenues.get('overrallTotal')?.setValue(total);
    if (totalYear11 == 0 && totalYear22 == 0) {
      this.revenues.get('totalYear1')?.setValue('');
      this.revenues.get('totalYear2')?.setValue('');
      this.revenues.get('overrallTotal')?.setValue('');
      let totalYear1 = 0;
      let totalYear2 = 0;

      this.revenue.controls.forEach((row) => {
        totalYear1 += parseFloat(row.get('year1')?.value || 0);
        totalYear2 += parseFloat(row.get('year2')?.value || 0);

        // Set 'total' to an empty string if both years are zero
        if (totalYear11 === 0 && totalYear22 === 0) {
          row.get('total')?.setValue(''); // Set to an empty string
        }
      });
    }
  }
  // Prevent the Enter key from submitting the form
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default action
    }
  }
  // Delete
  deleteRow(index, id) {
    if (id == 0) {
      this.revenue.removeAt(index);
      let totalYear11 = 0;
      let totalYear22 = 0;
      this.revenue.controls.forEach((row) => {
        totalYear11 += parseFloat(row.get('year1')?.value || '');
        totalYear22 += parseFloat(row.get('year2')?.value || '');
      });
      this.revenues.get('totalYear1')?.setValue(totalYear11 || '');
      this.revenues.get('totalYear2')?.setValue(totalYear22 || '');
      const total = totalYear11 + totalYear22;
      this.revenues.get('overrallTotal')?.setValue(isNaN(total) ? '' : total);
    }
    if (this.revenue.length == 0) {
      this.addRevenue();
      let totalYear11;
      let totalYear22;
      this.revenue.controls.forEach((row) => {
        totalYear11 += parseFloat(row.get('year1')?.value || '');
        totalYear22 += parseFloat(row.get('year2')?.value || '');
      });
      this.revenues.get('totalYear1')?.setValue(totalYear11 || '');
      this.revenues.get('totalYear2')?.setValue(totalYear22 || '');
      const total = totalYear11 + totalYear22;
      this.revenues.get('overrallTotal')?.setValue(isNaN(total) ? '' : total);
    }
    if (id != 0) {
      this.getdata.amizhthLoader('show');
      this.makeapi
        .method(this.deletApi + id, '', 'delete')
        .subscribe((data) => {
          this.getdata.amizhthLoader('hide');
          if (data.responseStatus != 'Failed') {
            if (index == 0 && id != 0) {
              this.revenue.removeAt(index);
              if (this.revenue.length == 0) {
                this.addRevenue();
              }
            } else {
              this.revenue.removeAt(index);
            }
            this.notify.notifysuccess('Deleted SuccessFully');
            this.totalRemove();
          }
        });
    }
  }
  // Save
  saveBtn() {
    let getform = this.revenues.value;
    if (this.revenues.invalid) {
      this.revenues.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      getform.applicationId = sessionStorage.getItem('applicationId');
      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.router.navigateByUrl('admin/coe/declaration');
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
}
